module.exports = __webpack_public_path__ + "static/sport/bgi-h5.1b39efb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/bgi-h5.png
// module id = 6NRW
// module chunks = 0